// extracted by mini-css-extract-plugin
export var container = "mainList-module--container--KGtcF";
export var lottieText = "mainList-module--lottieText--24sXg";
export var finger = "mainList-module--finger--2zWZZ";
export var mainList = "mainList-module--mainList--3iW-N";
export var mainList_marker = "mainList-module--mainList_marker--34pVb";
export var mainList_text = "mainList-module--mainList_text--20TNU";